import { AnyEntity, AnyEntityId, EntityType } from "@mapmycustomers/shared/types/entity";

import EditActivityFocusableField from "../../component/activity/type/EditActivityFocusableField";
import RecordPaneTab from "../../enum/preview/RecordPaneTab";

import RecordPaneReturnState from "./RecordPaneReturnState";

export enum EntityViewSource {
  GLOBAL_SEARCH,
}

export interface EntityViewParentEntity {
  entityId: AnyEntityId;
  entityName: string;
  entityType: EntityType;
  returnState?: RecordPaneReturnState; // where the parent pane was when this record opened
}

interface EntityViewPayload {
  edit?: boolean;
  editValues?: Partial<AnyEntity>; // currently is only used with Activity, but can be anything
  elementId?: string;
  entityId?: AnyEntityId;
  entityType?: EntityType;
  focusedFieldName?: EditActivityFocusableField;
  focusOnPin?: boolean;
  parentEntity?: EntityViewParentEntity;
  requiredFieldsOnly?: boolean;
  returnState?: RecordPaneReturnState; // where to put this pane back when it opens through Back
  source?: EntityViewSource;
  tab?: RecordPaneTab;
  zIndex?: number; // if a custom z-index is needed
}

export default EntityViewPayload;
